<template>
    <div id="resource-destination-control">
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="mb-4 mt-4 w-full">
                    <vs-table stripe :data="loanUseCases" noDataText="No se han generado registros">
                        <template slot="header">
                            <h3>Destinos del recurso</h3>
                            <vs-button @click.stop="popupActivo = true" class="mb-2 mr-2" size="small" color="success">Agregar destino</vs-button>
                        </template>
                            <template slot="thead">
                            <vs-th class="bold">PID</vs-th>
                            <vs-th class="bold">PfID</vs-th>
                            <vs-th class="bold">NOMBRE</vs-th>
                            <vs-th class="bold">ACCIONES</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                                <vs-td :data="data[indextr].project_id">
                                {{ (data[indextr].project_id) }}
                                </vs-td>

                                <vs-td :data="data[indextr].project_finances_id">
                                {{ (data[indextr].project_finances_id) }}
                                </vs-td>

                                <vs-td :data="data[indextr].loan_use_cases_name">
                                {{ uppercase(data[indextr].loan_use_cases_name) }}
                                </vs-td>

                                <vs-td :data="data[indextr].id">
                                    <vs-button @click="deleteDestinationRequest(tr)" radius size="small" type="border" icon="delete" color="danger"></vs-button>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </div>
            </div>
        </div>

        <vs-popup title="Agregar destino" :active.sync="popupActivo">
            <div class="vx-row">
                <div class="vx-col">
                    <vx-card title="Nuevo destino">
                        <p class="mb-2">Define el destino para los recursos del crédito, este será utilizado en la creación de los contratos del Grupo 1.</p>
                        <vs-divider></vs-divider>
                        <vs-select
                            class="w-full"
                            v-model.lazy="destinationSelected"
                            name="destinationSelected"
                            placeholder="Seleccione una opción">
                            
                            <vs-select-item
                            :key="index"
                            :value="item.id"
                            :text="item.select_name"
                            v-for="(item,index) in collections.loan_use_cases"
                            class="w-full"
                            />
                        </vs-select>
                        <div class="flex flex-wrap items-center justify-end">
                            <vs-button type="line" class="mt-4" @click="popupActivo = false">Cerrar</vs-button>
                            <vs-button class="ml-2 mt-4" @click="saveDestinationRequest()">Guardar cambios</vs-button>
                        </div>
                    </vx-card>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import inputHelper from '@components/mixins/inputHelper';
export default {
    name: "resources-destination-control",
    props: ["projectId"],
    mixins: [
        inputHelper
    ],
    data() {
        return {
            loanUseCases: [],
            collections: {
                loan_use_cases: []
            },
            popupActivo: false,
            destinationSelected: null,
            currentProjectFinanceId: null,
            itemToDelete: null
        }
    },
    mounted() {
        this.getCurrentLoanUseCases();
        this.getCollections();
    },
    methods: {
        async getCollections(){
            try {
                let collectionsObjects = ['getLoanUseCases'];
                let params = "with[]=" + collectionsObjects.join("&with[]=");
                let res = await axios.get(`/api/v1/forms/getFormCollections?${params}`);
                let colls = res.data;
                this.collections.loan_use_cases = colls.getLoanUseCases;
            }
            catch (e) {
                this.warn(e);
                this.failed = true;
            }
        },
        async getCurrentLoanUseCases()
        {
            try {
                const res = await axios.get(`/api/get/loan-use-cases/by-project/${this.projectId}`)
                this.loanUseCases = res.data;
            } catch (error) {
                console.error(error);
            }
        },

        saveDestinationRequest(item) {
            this.currentProjectFinanceId = item;
            this.$vs.dialog({
                type: 'alert',
                color: 'warning',
                title: "Nuevo destino",
                text: "Se agregará un nuevo destino para el recurso del crédito ¿Quiere continuar?",
                acceptText: "Aceptar",
                cancelText: 'Cancelar',
                accept: this.doRequestSave
            });
        },
        async doRequestSave() {
            try {
                this.showLoading(true);
                const payload = {
                    project_id: this.projectId
                    , new_relation: this.destinationSelected
                }
                await axios.post(`/api/post/loan-use-cases/new`, payload);
                this.getCurrentLoanUseCases();
                this.showLoading(false);
            } catch (error) {
                this.showLoading(false);
            }
        },

        deleteDestinationRequest(item) {
            this.itemToDelete = item;
            this.$vs.dialog({
                type: 'alert',
                color: 'danger',
                title: "Borrar destino",
                text: "Se eliminará un destino para el recurso del crédito ¿Quiere continuar?",
                acceptText: "Aceptar",
                cancelText: 'Cancelar',
                accept: this.doRequestDelete
            });
        },
        async doRequestDelete() {
            try {
                this.showLoading(true);
                const payload = {
                    project_finance_id: this.itemToDelete.project_finances_id
                    , loan_use_case_id: this.itemToDelete.loan_use_cases_id
                }
                await axios.post(`/api/delete/loan-use-cases`, payload);
                this.getCurrentLoanUseCases();
                this.showLoading(false);
            } catch (error) {
                this.showLoading(false);
            }
        }
    }

}
</script>

<style>
    .con-vs-dialog {
        z-index: 9999999 !important;
    }

</style>